module.exports = __webpack_public_path__ + "media/images/avatar-c2d649c2e99066b4ee8a58cc0821ccc6.svg";